import { Outlet } from 'react-router-dom';
import { FlexContainer } from 'components';
import { TenancyContext, useTenancies, useTenancy } from 'state';
import { withCollectionItem, withInitialization } from 'hoc';
import combineHOCs from 'lib/combineHOCs';

/**
 * TenanciesViewLayout
 *
 * @return {JSX.Element}
 */

const TenanciesViewLayout = () => {
  return (
    <FlexContainer column alignCenter>
      <Outlet />
    </FlexContainer>
  );
};

export default combineHOCs(
  withCollectionItem(useTenancies, TenancyContext, 'tenancyUid'),
  withInitialization(useTenancy)
)(TenanciesViewLayout);
